import api from './api'
import other from './other'

const config = {
  api,
  other,
}

export default config



// WEBPACK FOOTER //
// ./src/config/index.js